import { useContext } from "react";
import { useLocation, useParams } from "react-router-dom";
import Navbar from "../components/Navbar/Navbar";
import Header from "../components/Header/Header";
import { AppContext } from "../Context/Context";
import "../App.css";
import MapModal from "../components/Modal/MapModal/MapModal";
import { isScreenBigger } from "../util/helper/helperFunctions";
import WarehouseModal from "../components/Modal/WarehouseModal/WarehouseModal";
import { useSelector } from "react-redux";

const Wrapper = ({ children }) => {
  const { plantCode } = useParams();
  const { pathname } = useLocation();
  const { siteSelectionModal, location, warehouseData, shiftPerformanceData } =
    useContext(AppContext);
  const { navQualityHeatmapIsEnabled } = useSelector(
    (state) => state.navHeatmap
  );
  return (
    <div className="App">
      <Navbar />
      <div className="dashboard-container">
        <div
          className="flexible-screen"
          style={{
            display: navQualityHeatmapIsEnabled && "block"
          }}
        >
          <div className="flexible-left-screen">
            <Header />
            {children}
          </div>
          {(window.innerWidth > 2500 || isScreenBigger()) &&
          pathname.slice(1) === plantCode ? (
            <div className="flexible-right-screen">
              <WarehouseModal
                warehouseData={warehouseData}
                shiftData={shiftPerformanceData}
              />
            </div>
          ) : null}
        </div>
      </div>

      {siteSelectionModal && <MapModal selectedLocation={location} />}
    </div>
  );
};

export default Wrapper;
